"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.URL_BASE = void 0;
exports.URL_BASE = "/payment";
//# sourceMappingURL=Base.js.map